import {Component, ViewChild} from "@angular/core"; import { Location } from "@angular/common";
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';
import { ActivatedRoute, Router } from '@angular/router';
import { HistoriqueEntretienPreventifEntite } from 'src/app/entites/mecanique/historique-entretien-preventif';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { PrixFournisseurEntite } from 'src/app/entites/prix-fournisseur';
import { MenuItem, TreeNode } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu/public_api';
import { VadEntite } from 'src/app/entites/mecanique/verification-avant-depart';
import { VadService } from 'src/app/services/vad-service';

export interface ParametresDetailVad {
    vadId: number;
}

@Component({
    templateUrl: './detail-vad.component.html',
})
export class DetailVadComponent extends BaseComponent {

    donnees: ParametresDetailVad;

    vad: VadEntite;

    contenuMenuContextuel: MenuItem[];
    @ViewChild('menuContextuel') menuContextuel: ContextMenu;
    
    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute, 
        routerService: Router,
        appMain: AppMainComponent, location: Location, 
        private vadService: VadService,
        public ref: DynamicDialogRef, 
        public config: DynamicDialogConfig) {

            super(sdb, profilService, route, routerService, appMain); }

    ngOnInit() {

        this.donnees = this.config.data;

        this.vadService.ObtenirVad(this.donnees.vadId).then(res => {
            this.vad = res.valeur;

            this.CompleterChargement();
        });        
    }

     fermer() {
        this.ref.close(null);
    }

    surMenuContextuel(event, vad: VadEntite) {

        this.contenuMenuContextuel = [
            {
                label: 'Voir le bon de travail',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('temp_mec'),
                //TODO
                command: () => { this.ref.close(null); this.routerService.navigateByUrl('mecanique/soumissions/nouveau'); }
            },
        ];

        this.menuContextuel.toggle(event);

    }
}